/*
 * @Version: 1.0.0
 * @Description: file content
 * @Autor: zhiqiang.xia@dsicm.com
 * @Date: 2023-01-10 10:08:05
 * @LastEditors: zhiqiang.xia@dsicm.com
 * @LastEditTime: 2023-02-02 14:02:23
 * @FilePath: \新建文件夹 (2)\dsicm-admin-web\src\views\pushManagement\api\index.js
 */

import request from '@/utils/req.js';


//推送服务包新增（新增计划）
export function pushPackage(params) {
    return request.post('/admin/push-package', params)
}
//计划管理更新（编辑保存计划）
export function editPackage(params) {
    return request.put('/admin/push-package', params)
}
//计划管理 启用 | 禁用
export function packageStatus(params) {
    return request.post('/admin/push-package/enable', params)
}
//计划管理分页查询
export function packagePage(params) {
    return request.get('/admin/push-package/page', params)
}
//计划管理详情
export function packageDetail(params) {
    return request.get(`/admin/push-package/${params}`)
}
//计划管理删除
export function packageDelete(params) {
    return request.delete(`/admin/push-package/${params}`)
}
//在线教程弹窗
export function apitTrainChapter(params) {
    return request.get("/admin/train-chapter/page", params);
}
//宣教列表分页查询
export function apiGetMission(params) {
    return request.post("/admin/mission/page", params);
}
//获取公众号列表
export function apiPublicList(params) {
    return request.get("/admin/push-package-xcx-template/queryPublicList", params);
}
//获取小程序模板列表
export function queryMiniprogramList(params) {
    return request.get("/admin/push-package-xcx-template/queryMiniprogramList", params);
}
//根据appId获取当前公众号下的所有模板
export function queryByAppId(params) {
    return request.get(`/admin/push-package-xcx-template/queryByAppId?appId=${params}`);
}

